import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidationErrors, } from '@angular/forms';

import { BaseField } from '../fields/base-field';

@Component({
    selector: 'ui-form-field-renderer',
    templateUrl: './form-field-renderer.component.html',
    styleUrls: ['./form-field-renderer.component.scss'],
    standalone: false
})
export class FormFieldRendererComponent implements OnInit, OnChanges {

    @Input() field!: BaseField | any;
    @Input() public entity!: any;
    @Input() formGroup!: UntypedFormGroup;
    @Input() item: any;
    @Input() isVisible = true;
    @Input() condicional?: (f: UntypedFormGroup | undefined) => void;
    @Input() set disabled(val: any) {
        val ? this.controle.enable() : this.controle.disable();
    }
    
    public get controle(): AbstractControl {
        return this.formGroup!.get(this.field!.property);
    }

    public get errors(): ValidationErrors[] {
        let errors: ValidationErrors[] = [];
        
        if(this.controle instanceof UntypedFormGroup){
            const controls = (this.controle as UntypedFormGroup).controls;
            
            for (const formKey in controls) {
                let validation = controls[formKey].errors;
                if(validation) {
                    let key = Object.keys(validation)[0];
                    if (!errors.find((v) => Object.keys(v)[0] === key)) {
                        errors.push(validation);
                    }
                }
            }
        }else if(this.controle.errors){
            errors.push(this.controle.errors);
        }
        
        return errors;
    }

    constructor() { }
    ngOnChanges(changes: SimpleChanges): void {
        this.condicional && this.condicional(this.formGroup);
    }

    ngOnInit(): void {
    }

    validatorMessage(error: ValidationErrors): string {
        const campo = this.field?.label;
        if (error['required']) {
            return `${campo} é obrigatório`;
        }

        if (error['minlength']) {
            const { requiredLength, actualLength } = error['minlength'];
            return `${campo} deve ter no mínimo ${requiredLength} caracteres, atual ${actualLength}`;
        }

        if (error['maxlength']) {
            const { requiredLength, actualLength } = error['maxlength'];
            return `${campo} deve ter no máximo ${requiredLength} caracteres, atual ${actualLength}`;
        }

        if (error['pattern']) {
            return `Valor não é válido`;
        }

        if (error['min'] || error['max']) {
            const { minimo, maximo } = this.limitesValidators();
            if (minimo != null && maximo != null) {
                const { actual } = error['min'] ?? error['max'];
                return `${campo} deve estar entre ${minimo} e ${maximo}, atual ${actual}`;
            }
        }

        if (error['min']) {
            const { min, actual } = error['min'];
            return `${campo} deve ser no mínimo ${min}, atual ${actual}`;
        }

        if (error['max']) {
            const { max, actual } = error['max'];
            return `${campo} deve ser no máximo ${max}, atual ${actual}`;
        }

        if (error['email']) {
            return `E-mail não é válido`;
        }

        return '';
    }

    // Os erros de Validators.min/max trazem só o limite violado; para obter a faixa completa,
    // o validator do controle é avaliado com valores extremos.
    private limitesValidators(): { minimo?: number; maximo?: number } {
        const validator = this.controle?.validator;
        if (!validator) {
            return {};
        }

        const avaliar = (value: number) => validator({ value } as AbstractControl);
        return {
            minimo: avaliar(-Number.MAX_SAFE_INTEGER)?.['min']?.min,
            maximo: avaliar(Number.MAX_SAFE_INTEGER)?.['max']?.max,
        };
    }
}
